// Tacit's public search/share metadata (#3756, epic #3751). Single source for
// the runtime document.title on Tacit-default (non-white-labelled) surfaces;
// frontend/index.html carries the same strings statically for crawlers that
// don't run JS, and __tests__/siteMeta3756.test.jsx pins the two together.
//
// British spelling throughout the public site: "practise" is the verb.
//
// The meta description is an A/B pair (M1/M2). M1 ships first; the per-URL
// rotation plumbing is #3756 item 3 and depends on the item-2 crawlability
// decision, because a crawler must see one stable description per URL.
export const TACIT_SITE_TITLE = 'Tacit: Practise the job you want. Prove you can do it';

// The in-app fallback tagline for any org without its own (BrandingContext's
// TACIT_DEFAULTS). Deliberately NOT the new headline: an org with no tagline
// renders "<app> - <this>", so changing it would put Tacit's headline on
// another org's title.
export const TACIT_DEFAULT_TAGLINE = 'Practice Difficult Conversations';

export const TACIT_META_DESCRIPTIONS = {
  M1: 'Work simulations for workforce programmes and L&D teams: realistic work, a real deliverable, AI stakeholders who push back, and personal coaching.',
  M2: 'Work simulations for workforce programmes and L&D teams. Do realistic work, defend it to AI stakeholders, and get personal assessment and coaching.',
};

export const TACIT_META_DESCRIPTION = TACIT_META_DESCRIPTIONS.M1;

// The tab title for a resolved branding object (BrandingContext's value).
// Powered-by orgs: "<app> — Powered by <x>". Tacit's own surfaces (default
// branding and no custom tagline): the public site title. Every other org:
// "<app> - <tagline>". BrandingContext and HomePageV2 both write
// document.title, so both go through here; a white-labelled org must never
// get Tacit's headline.
export function documentTitleFor(branding) {
  if (branding.poweredBy) return `${branding.appName} — Powered by ${branding.poweredBy}`;
  if (branding.isTacitDefault && branding.tagline === TACIT_DEFAULT_TAGLINE) return TACIT_SITE_TITLE;
  return `${branding.appName} - ${branding.tagline}`;
}
